import React from 'react';
import { useDeviceDetect } from './ResponsiveComponents';

const MobileDebugger = () => {
  const { isMobile, isTablet, screenSize } = useDeviceDetect();

  // Don't show in production or if explicitly hidden
  if (process.env.NODE_ENV === 'production') return null;

  return (
    <div className="fixed top-4 right-4 bg-black text-white p-3 text-xs z-50 rounded shadow-lg max-w-xs">
      <div className="font-bold mb-2">📱 Device Info</div>
      <div className="space-y-1">
        <div>Width: {window.innerWidth}px</div>
        <div>Height: {window.innerHeight}px</div>
        <div>Screen: {screenSize}</div>
        <div className="flex gap-2">
          <span className={isMobile ? 'text-green-400' : 'text-gray-400'}>
            📱 Mobile: {isMobile ? 'Yes' : 'No'}
          </span>
        </div>
        <div className="flex gap-2">
          <span className={isTablet ? 'text-green-400' : 'text-gray-400'}>
            📟 Tablet: {isTablet ? 'Yes' : 'No'}
          </span>
        </div>
        <div className="mt-2 text-yellow-300">
          Breakpoints:
        </div>
        <div className="text-xs">
          <div>xs: &lt; 640px</div>
          <div>sm: ≥ 640px</div>
          <div>md: ≥ 768px</div>
          <div>lg: ≥ 1024px</div>
          <div>xl: ≥ 1280px</div>
        </div>
      </div>
    </div>
  );
};

export default MobileDebugger;